export default __webpack_public_path__ + "static/media/languageIcon.484b7697.png";